<template>
  <v-card>
    <v-card-title>
      <span class="headline">Editar configuración</span>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12" class="font-weight-bold">
          {{ item.settings.description }}
        </v-col>
        <v-col cols="12">
          <v-select
            v-if="item.settings.type === 'boolean'"
            :label="item.label"
            :items="item.settings.options"
            :value="item.value"
            @input="(payload) => (form.value = payload)"
          ></v-select>
          <v-text-field
            v-if="
              item.settings.type !== 'textarea' &&
              item.settings.type !== 'select' &&
              item.settings.type != 'boolean' &&
              item.settings.type !== 'select_multiple' &&
              item.settings.type !== 'select_from_server'
            "
            :type="textOrPassword"
            :value="item.value"
            :error-messages="error_input.value"
            :label="item.label"
            @input="(payload) => (form.value = payload)"
            :append-icon="textOrPasswordIcon"
            @click:append="password_visible = !password_visible"
          ></v-text-field>
          <v-textarea
            v-if="item.settings.type === 'textarea'"
            auto-grow
            :value="item.value"
            :error-messages="error_input.value"
            :label="item.label"
            counter="255"
            @input="(payload) => (form.value = payload)"
          ></v-textarea>
          <v-select
            v-if="
              item.settings.type === 'select' ||
              item.settings.type === 'select_multiple'
            "
            :items="item.settings.options"
            :multiple="item.settings.type === 'select_multiple'"
            :chips="item.settings.type === 'select_multiple'"
            :deletable-chips="item.settings.type === 'select_multiple'"
            :type="item.settings.type"
            :value="
              item.settings.type === 'select_multiple'
                ? item.value.split(',')
                : item.value
            "
            :error-messages="error_input.value"
            :rules="[]"
            :label="item.label"
            @input="(payload) => (form.value = payload.join(','))"
          ></v-select>
          <!--  <v-autocomplete
            v-model="selected"
            v-if="item.settings.type === 'autocomplete'"
            :items="item.settings.options"
            cache-items
            :loading="loading"
            :search-input.sync="search"
            chips
            item-text=""
            item-value=""
            label=""
            placeholder=""
            prepend-icon="md0-animation"
            clearable
            multiple=""
            @click:clear="$emit('selected', [])"
          ></v-autocomplete> -->
          <v-select
            v-if="item.settings.type === 'select_from_server'"
            :label="item.label"
            :items="zona_horaria"
            :value="item.value"
            @input="(payload) => (form.value = payload)"
            item-text="text"
            item-value="value"
          ></v-select>
        </v-col>
      </v-row>
      <v-alert v-model="mostrar_alert" dismissible :type="type_alert">
        <template v-html="html_alert" />
      </v-alert>
    </v-card-text>

    <v-card-actions>
      <v-spacer />
      <v-btn color="gray darken-1" @click="close"> Cancelar </v-btn>
      <v-btn
        color="blue darken-1"
        class="white--text"
        :loading="loading"
        :disabled="loading"
        @click="guardar"
      >
        Guardar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from "axios";

export default {
  name: "FormConfiguracion",
  props: {
    item: {
      type: [Array, Object],
      default: () => {
        return {
          id: 0,
          label: "",
        };
      },
    },
  },
  data() {
    return {
      form: Object.assign(this.$_clonar(this.item)),
      error_input: {
        nombre: "",
        key: "",
        label: "",
      },
      loading: false,
      mostrar_alert: false,
      type_alert: "success",
      html_alert: "",
      password_visible: false,
      zona_horaria: [],
      selected_zona_horaria: "",
      selected: [],
      search: "",
    };
  },
  computed: {
    editar() {
      return this.item.id > 0;
    },
    textOrPassword() {
      if (this.item.settings.type !== "password") {
        return this.item.settings.type;
      }
      return this.password_visible ? "text" : "password";
    },
    textOrPasswordIcon() {
      if (this.item.settings.type !== "password") {
        return "";
      }
      return this.password_visible ? "mdi-eye" : "mdi-eye-off";
    },
  },
  watch: {
    item(val) {
      this.form = Object.assign({}, val);
    },
    search(val) {
      // Items have already been requested
      if (
        this.loading ||
        typeof val !== "string" ||
        (typeof val === "string" && val.length < 1)
      ) {
        return;
      }

      // Lazily load input items
      this.loadData();
    },
    selected(val) {
      if (val.length < 1) {
        return;
      }

      this.$emit("selected", this.selected);
    },
  },
  methods: {
    listaZonaHoraria() {
      this.loading = true;
      axios
        .get("/api/zona-horaria/listar")
        .then(({ data }) => {
          this.zona_horaria = data.data;
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    close() {
      this.form.id = 0;
      this.form.nombre = "";
      this.$emit("close", true);
    },
    guardar() {
      let url_target = this.editar
        ? `/api/configuraciones/actualizar/${this.item.id}`
        : "/api/configuraciones/guardar";
      this.loading = true;
      this.error_input.nombre = "";
      axios
        .post(url_target, this.form)
        .then(({ data }) => {
          this.loading = false;
          /*window.console.log('IsData', data);*/
          if (data.success) {
            this.form.label = "";
            this.$emit("save", data.message);
          }
        })
        .catch((error) => {
          this.loading = false;

          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            /*window.console.log(error.response.data);
                            window.console.log(error.response.status);
                            window.console.log(error.response.headers);
                            window.console.info("Es error");*/
            if (error.response.status === 422) {
              /*window.console.info("Es error");
                                window.console.log(error.response.data.data);*/
              this.error_input = Object.assign({}, error.response.data.data);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            /*window.console.log(error.request);*/
          } else {
            // Something happened in setting up the request that triggered an Error
            /*window.console.log('Error', error.message);*/
          }
        });
    },
  },
  mounted() {
    this.listaZonaHoraria();
  },
};
</script>

<style scoped>
</style>
